import { getSessionValues } from '@/providers/session-provider/get-session-values';

export function getSocketToken(): string {
  const { userId, token, customerId } = getSessionValues();
  return btoa(`${customerId}.${userId}:${token}`);
}
